import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetCommands } from "../Responses/GetCommands";

export async function getCommands() {
	let response = await getAPIResponse("/command-scheduler/commands");
	if (response === null) {
		return null;
	}
	let getCommands = GetCommands.createFromResponseData(response);
	return getCommands;
}